
import React, { useEffect, useState } from "react";

export default function App() {


  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&family=Space+Grotesk:wght@400;500;600;700&display=swap');

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: 'DM Sans', sans-serif;
          background: #080914;
          color: white;
        }

        .maintenance {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          position: relative;
          overflow: hidden;
          isolation: isolate;
          background: #080914;
        }

        .grid {
          position: absolute;
          inset: 0;
          z-index: -1;
          opacity: .12;
          background-image:
            linear-gradient(rgba(255,255,255,.12) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,.12) 1px, transparent 1px);
          background-size: 55px 55px;
        }

        .glow {
          position: absolute;
          width: 400px;
          height: 400px;
          border-radius: 50%;
          filter: blur(110px);
          opacity: .4;
          z-index: -1;
          animation: float 8s infinite alternate ease-in-out;
        }

        .glow.one {
          background: #743cff;
          top: -150px;
          left: -150px;
        }

        .glow.two {
          background: #087cbd;
          right: -150px;
          bottom: -150px;
          animation-delay: 2s;
        }

        @keyframes float {
          from { transform: translateY(-30px); }
          to { transform: translateY(50px); }
        }

        .navbar {
          max-width: 1200px;
          width: 100%;
          margin: auto;
          padding: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .logo {
          font-family: 'Space Grotesk', sans-serif;
          font-size: 28px;
          font-weight: 700;
        }

        .logo span {
          color: #a78bfa;
        }

        .online {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 12px;
          color: #b5b5c7;
        }

        .dot {
          height: 8px;
          width: 8px;
          background: #42e6a4;
          border-radius: 50%;
          box-shadow: 0 0 15px #42e6a4;
          animation: pulse 1.5s infinite;
        }

        @keyframes pulse {
          50% { opacity: .3; }
        }

        .main-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          padding: 60px 20px 90px;
        }

        .icon-circle {
          width: 85px;
          height: 85px;
          border-radius: 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 38px;
          color: #c4b5fd;
          background: rgba(139,92,246,.12);
          border: 1px solid rgba(167,139,250,.3);
          box-shadow: 0 0 50px rgba(139,92,246,.15);
          margin-bottom: 35px;
          animation: rotateFloat 4s infinite ease-in-out;
        }

        @keyframes rotateFloat {
          0%, 100% { transform: translateY(0) rotate(-5deg); }
          50% { transform: translateY(-10px) rotate(5deg); }
        }

        .tag {
          padding: 10px 20px;
          background: rgba(139,92,246,.1);
          border: 1px solid rgba(167,139,250,.3);
          color: #c4b5fd;
          border-radius: 50px;
          font-size: 11px;
          letter-spacing: 2px;
          font-weight: 700;
          margin-bottom: 25px;
        }

        h1 {
          font-family: 'Space Grotesk', sans-serif;
          font-size: clamp(42px, 7vw, 78px);
          line-height: 1.12;
          letter-spacing: -3px;
        }

        h1 span {
          background: linear-gradient(90deg, #a78bfa, #60a5fa, #a78bfa);
          background-size: 200%;
          color: transparent;
          background-clip: text;
          -webkit-background-clip: text;
          animation: shine 5s linear infinite;
        }

        @keyframes shine {
          to { background-position: 200%; }
        }

        .description {
          max-width: 530px;
          color: #9999ae;
          font-size: 15px;
          line-height: 1.9;
          margin: 25px 0 30px;
        }

        .progress {
          width: 220px;
          height: 5px;
          background: rgba(255,255,255,.1);
          border-radius: 20px;
          overflow: hidden;
          margin-bottom: 12px;
        }

        .progress-bar {
          width: 70%;
          height: 100%;
          background: linear-gradient(90deg, #8b5cf6, #60a5fa);
          border-radius: 20px;
          animation: progress 3s ease-in-out infinite alternate;
        }

        @keyframes progress {
          from { width: 55%; }
          to { width: 80%; }
        }

        .progress-label {
          font-size: 10px;
          color: #88889e;
          letter-spacing: 2px;
          margin-bottom: 35px;
        }

        .countdown {
          display: flex;
          gap: 12px;
          margin-bottom: 40px;
        }

        .time-box {
          width: 90px;
          padding: 17px 10px;
          border-radius: 13px;
          background: rgba(255,255,255,.045);
          border: 1px solid rgba(255,255,255,.1);
          backdrop-filter: blur(15px);
        }

        .time-box strong {
          font-family: 'Space Grotesk', sans-serif;
          display: block;
          font-size: 30px;
        }

        .time-box small {
          color: #88889e;
          font-size: 9px;
          letter-spacing: 1.5px;
        }

        .subscribe {
          width: 100%;
          max-width: 450px;
        }

        .subscribe h3 {
          font-family: 'Space Grotesk', sans-serif;
          font-size: 20px;
          margin-bottom: 8px;
        }

        .subscribe p {
          font-size: 13px;
          color: #9292a7;
          margin-bottom: 18px;
        }

        form {
          display: flex;
          gap: 8px;
          padding: 6px;
          background: rgba(255,255,255,.06);
          border: 1px solid rgba(255,255,255,.13);
          border-radius: 12px;
        }

        input {
          flex: 1;
          min-width: 0;
          background: transparent;
          border: none;
          outline: none;
          padding: 12px;
          color: white;
          font-size: 13px;
        }

        input::placeholder {
          color: #85859b;
        }

        button {
          background: linear-gradient(135deg, #8b5cf6, #6366f1);
          color: white;
          border: none;
          padding: 12px 20px;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 700;
          transition: .3s;
        }

        button:hover {
          transform: translateY(-2px);
          box-shadow: 0 0 20px rgba(139,92,246,.4);
        }

        .success {
          color: #42e6a4;
          padding: 15px;
          border: 1px solid rgba(66,230,164,.3);
          border-radius: 10px;
          background: rgba(66,230,164,.08);
        }

        footer {
          width: 100%;
          max-width: 1200px;
          margin: auto;
          padding: 25px 30px;
          border-top: 1px solid rgba(255,255,255,.08);
          display: flex;
          justify-content: space-between;
          gap: 15px;
          color: #77778c;
          font-size: 10px;
          letter-spacing: 1px;
        }

        @media(max-width: 600px) {
          .navbar { padding: 25px 20px; }
          .logo { font-size: 23px; }
          .online { font-size: 10px; }
          .main-content { padding: 60px 18px; }
          h1 { letter-spacing: -2px; }
          .description { font-size: 13px; }
          .countdown { gap: 7px; }
          .time-box { width: 75px; padding: 14px 5px; }
          .time-box strong { font-size: 25px; }
          form { flex-direction: column; }
          button { width: 100%; }
          footer {
            flex-direction: column;
            align-items: center;
            text-align: center;
          }
        }
      `}</style>

      <div className="maintenance">
        <div className="grid"></div>
        <div className="glow one"></div>
        <div className="glow two"></div>

        <nav className="navbar">
          {/* <div className="logo">NOVA<span>.</span></div> */}
          <div className="online">
            <span className="dot"></span>
            SYSTEM MAINTENANCE
          </div>
        </nav>

        <section className="main-content">
          <div className="icon-circle">⚙</div>

          <div className="tag">
            ✦ WE'LL BE BACK SOON
          </div>

          <h1>
            We're making
            <br />
            <span>things better.</span>
          </h1>

          <p className="description">
            We're currently upgrading our website to bring
            you a faster, smoother and better experience.
            We'll be back online shortly. Thank you for your patience!
          </p>

          <div className="progress">
            <div className="progress-bar"></div>
          </div>

          <div className="progress-label">
            IMPROVING YOUR EXPERIENCE
          </div>


        </section>

    
      </div>
    </>
  );
}
